// =============================================
// COMPONENTE: CHECKLIST NODE
// =============================================
// Arquivo: ChecklistNode.tsx
// Descrição: Nó para operações com checklists
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Check } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const ChecklistNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, operation, checklistId, template, description, actions } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      create: 'Criar',
      update: 'Atualizar',
      complete: 'Completar',
      get: 'Buscar'
    };
    return labels[op] || op;
  };

  return (
    <div className={`flow-node checklist-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header checklist-header">
        <Check className="node-icon" size={18} />
        <span className="node-title">{label || 'Checklist'}</span>
      </div>

      <div className="node-body">
        {operation && (
          <div className="node-field">
            <span className="field-label">Operação:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {template && (
          <div className="node-field">
            <span className="field-label">Template:</span>
            <span className="field-value">{template}</span>
          </div>
        )}
        {checklistId && (
          <div className="node-field">
            <span className="field-label">ID:</span>
            <span className="field-value code">{checklistId}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default ChecklistNode;
